export const INDICATOR_ITEM_TYPE_ATTENTION = 0;
export const INDICATOR_ITEM_TYPE_DECLARED = 1;
export const INDICATOR_ITEM_TYPE_APPROVED = 2;
export const INDICATOR_ITEM_TYPE_REJECTED = 3;